import React, { Component } from "react";
import { toggleView } from "../actions";
import { connect } from "react-redux";
import track from "../lib/tracking";

const mapStateToProps = (state, ownProps) => {
  return {
    active: ownProps.destination === state.currentView
  };
};

const mapDispachToProps = (dispatch, ownProps) => {
  return {
    toggleView: () => dispatch(toggleView(ownProps.destination))
  };
};

class MenuButtonContainer extends Component {
  render() {
    const classes = ["menu__button", "color-gray"];
    this.props.active && classes.push("menu__button--active");

    return (
      <h3 className={classes.join(" ")} onClick={() => this.props.toggleView()}>
        {this.props.children}
      </h3>
    );
  }
}

const MenuButton = connect(mapStateToProps, mapDispachToProps)(
  MenuButtonContainer
);

export default MenuButton;



// WEBPACK FOOTER //
// ./src/components/MenuButton.js